import { computed, ComputedRef } from 'vue'
import { useStore } from 'vuex'

import { EditorPageStateModuleName } from '@/store/modules/modules'

export class EditorPageStateViewModel {
  private store = useStore()

  sourceCode: ComputedRef<string> = computed(() => this.store.getters[`${EditorPageStateModuleName}/sourceCode`])
  testFrameHeight: ComputedRef<number> = computed(
    () => this.store.getters[`${EditorPageStateModuleName}/testFrameHeight`]
  )
  maxTestFrameHeight: ComputedRef<number> = computed(
    () => this.store.getters[`${EditorPageStateModuleName}/maxTestFrameHeight`]
  )
  testPanelHeight: ComputedRef<number> = computed(
    () => this.store.getters[`${EditorPageStateModuleName}/testPanelHeight`]
  )
  isHandlingTestFrame: ComputedRef<boolean> = computed(
    () => this.store.getters[`${EditorPageStateModuleName}/isHandlingTestFrame`]
  )

  isFreeSpaceMode: ComputedRef<boolean> = computed(
    () => this.store.getters[`${EditorPageStateModuleName}/isFreeSpaceMode`]
  )
  isErrorShow: ComputedRef<boolean> = computed(() => this.store.getters[`${EditorPageStateModuleName}/isErrorShow`])

  errorMessage: ComputedRef<string | null> = computed(
    () => this.store.getters[`${EditorPageStateModuleName}/errorMessage`]
  )

  isPastingIOConsole: ComputedRef<boolean> = computed(
    () => this.store.getters[`${EditorPageStateModuleName}/isPastingIOConsole`]
  )

  setSourceCode(sourceCode: string): void {
    this.store.commit(`${EditorPageStateModuleName}/setSourceCode`, { sourceCode })
  }

  setIsHandlingTestFrame(flag: boolean): void {
    this.store.commit(`${EditorPageStateModuleName}/setIsHandlingTestFrame`, {
      flag: flag
    })
  }

  setIsFreeSpaceMode(isFreeSpaceMode: boolean): void {
    this.store.commit(`${EditorPageStateModuleName}/setIsFreeSpaceMode`, { isFreeSpaceMode })
  }

  setIsErrorShow(isErrorShow: boolean): void {
    this.store.commit(`${EditorPageStateModuleName}/setIsErrorShow`, { isErrorShow })
  }

  setIsPastingIOConsole(isPastingIOConsole: boolean): void {
    this.store.commit(`${EditorPageStateModuleName}/setIsPastingIOConsole`, { isPastingIOConsole })
  }

  updateMaxTestFrameHeight(height: number): void {
    this.store.dispatch(`${EditorPageStateModuleName}/updateMaxTestFrameHeight`, { height })
  }

  updateTestFrameHeight(height: number): void {
    this.store.dispatch(`${EditorPageStateModuleName}/updateTestFrameHeight`, { height })
  }
}
